// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner-border-costum[data-v-ca8972ce] {\n  width: 22px;\n  height: 22px;\n  border-width: 3px;\n}\n.btn-costum[data-v-ca8972ce] {\n  padding: 0px;\n  width: 36px;\n  height: 36px;\n}", ""]);
// Exports
module.exports = exports;
